import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { Address } from "./Address";
import { OtherDetails } from "./OtherDetails";

export const GuestInformation: React.FC<any> = React.memo((props) => {
  const methods = useForm();
  const { handleSubmit, control, register } = methods;
  const navigate = useNavigate();

  const tabs = [
    { label: "Address", content: <Address /> },
    { label: "Other Details", content: <OtherDetails /> },
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };

  const onSubmit = async (data: any) => {
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  return (
    <Grid
      container
      sx={{
        minHeight: "100vh", // Full screen height
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
            }}
          >
            <Typography variant="h6" color={"green"}>
              Guest Information
            </Typography>
            <IconButton onClick={() => handleClick("/")}>
              <WSIcons.CloseIcon sx={{ backgroundColor: "red", color: "white" }} />
            </IconButton>
          </Grid>

          <Grid container sx={{ flexGrow: 1, padding: "16px" }}>
            {/* First Row: Phone, First Name, and Search Button */}
            <Grid container spacing={2}>
              {/* Phone */}
              <Grid item xs={12} sm={2}>
                <Typography>Phone</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <WSPhone label={""} id={"phone"} name={"phone"} control={control} />
              </Grid>

              {/* First Name */}
              <Grid item xs={12} sm={2}>
                <Typography>First Name</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <WSTextField
                  label={""}
                  {...register("firstname")}
                  id="firstname"
                  name="firstname"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>

              {/* Search Button */}
              <Grid item xs={12} sm={2}>
                <IconButton>
                  <WSIcons.SearchIcon onClick={() => handleClick("/guestsearchinfo")} />
                </IconButton>
              </Grid>
            </Grid>

            {/* Second Row: Guest Code, Last Name, and Sync Button */}
            <Grid container spacing={2} >
              {/* Guest Code */}
              <Grid item xs={12} sm={2}>
                <Typography>Guest Code</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <WSTextField
                  label={""}
                  {...register("guestcode")}
                  id="guestcode"
                  name="guestcode"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>

              {/* Last Name */}
              <Grid item xs={12} sm={2}>
                <Typography>Last Name</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <WSTextField
                  label={""}
                  {...register("lastname")}
                  id="lastname"
                  name="lastname"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>

              {/* Sync Button */}
              <Grid item xs={12} sm={2}>
                <IconButton>
                  <WSIcons.SyncIcon />
                </IconButton>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
            </Grid>
          </Grid>

          {/* Footer Section */}
          <Grid
            item
            sx={{
              backgroundColor: "#333",
              padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "auto", // Pushes the footer to the bottom
            }}
          >
            <Grid container spacing={2} alignItems="center" gap={3}>
              <Grid item>
                <WSIcons.GTranslateIcon sx={{ color: "white" }} />
              </Grid>
            </Grid>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "green",
                "&:hover": {
                  backgroundColor: "#388e3c",
                },
              }}
              onClick={handleSubmit(onSubmit)}
            >
              Finish
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
});
